import React from 'react';
import './Clients.css';

const Clients = () => {
  const testimonials = [
    {
      name: 'Rajesh Kumar',
      business: 'Kumar PG, Bangalore',
      rating: 5,
      comment: 'RentTick has transformed how we manage our PG. The automated billing and guest management features save us hours every day!'
    },
    {
      name: 'Priya Sharma',
      business: 'Sharma Hostel, Delhi',
      rating: 5,
      comment: 'Excellent software! Easy to use and the support team is very responsive. Highly recommended for hostel owners.'
    },
    {
      name: 'Amit Patel',
      business: 'Patel Residence, Mumbai',
      rating: 5,
      comment: 'Best investment for our PG business. The reports and analytics help us make better decisions.'
    }
  ];

  return (
    <div className="clients-page">
      <div className="page-header">
        <div className="header-container">
          <h1>Our Clients</h1>
          <p>Trusted by PG and Hostel owners across India</p>
        </div>
      </div>

      <div className="clients-container">
        <div className="stats-section">
          <div className="stat-box">
            <h3>500+</h3>
            <p>Happy Clients</p>
          </div>
          <div className="stat-box">
            <h3>10,000+</h3>
            <p>Guests Managed</p>
          </div>
          <div className="stat-box">
            <h3>99.9%</h3>
            <p>Satisfaction Rate</p>
          </div>
        </div>

        <div className="testimonials-section">
          <h2>What Our Clients Say</h2>
          <div className="testimonials-grid">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="testimonial-card">
                <div className="rating">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <i key={i} className="fas fa-star"></i>
                  ))}
                </div>
                <p className="comment">"{testimonial.comment}"</p>
                <div className="client-info">
                  <h4>{testimonial.name}</h4>
                  <p>{testimonial.business}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Clients;
